import { IGallery } from '../entities/IGallery';
import { IGalleryPhoto } from '../entities/IGalleryPhoto';
import { httpClient } from './helper/httpClient';

export interface ICreateGalleryParams {
  leadId: string;
  eventId?: string;
  name: string;
  selectionLimit?: number;
  clientMessage?: string;
}

export interface IUpdateGalleryParams {
  name?: string;
  selectionLimit?: number;
  clientMessage?: string;
}

export interface IGetPhotoUploadUrlParams {
  contentType: string;
  fileSize: number;
}

export interface IGetPhotoUploadUrlResponse {
  uploadUrl: string;
  fileKey: string;
}

export interface IConfirmPhotoParams {
  fileKey: string;
}

class GalleryService {
  private _baseURL = 'galleries';

  create(data: ICreateGalleryParams): Promise<IGallery> {
    return httpClient.post<ICreateGalleryParams, IGallery>(this._baseURL, data);
  }

  getAll(leadId?: string): Promise<IGallery[]> {
    return httpClient.get<null, IGallery[]>(this._baseURL, {
      params: leadId ? { leadId } : undefined,
    });
  }

  getById(id: string): Promise<IGallery> {
    return httpClient.get<null, IGallery>(`${this._baseURL}/${id}`);
  }

  update(id: string, data: IUpdateGalleryParams): Promise<IGallery> {
    return httpClient.patch<IUpdateGalleryParams, IGallery>(
      `${this._baseURL}/${id}`,
      data,
    );
  }

  publish(id: string): Promise<IGallery> {
    return httpClient.post<null, IGallery>(`${this._baseURL}/${id}/publish`);
  }

  archive(id: string): Promise<IGallery> {
    return httpClient.post<null, IGallery>(`${this._baseURL}/${id}/archive`);
  }

  remove(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }

  getPhotoUploadUrl(
    id: string,
    params: IGetPhotoUploadUrlParams,
  ): Promise<IGetPhotoUploadUrlResponse> {
    return httpClient.post<
      IGetPhotoUploadUrlParams,
      IGetPhotoUploadUrlResponse
    >(`${this._baseURL}/${id}/photos/upload-url`, params);
  }

  confirmPhoto(id: string, params: IConfirmPhotoParams): Promise<IGalleryPhoto> {
    return httpClient.post<IConfirmPhotoParams, IGalleryPhoto>(
      `${this._baseURL}/${id}/photos`,
      params,
    );
  }

  removePhoto(id: string, photoId: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}/photos/${photoId}`);
  }
}

export default new GalleryService();
